import { Badge, Stack } from '@mui/material';
import React from 'react'

const BoostOwnershipArrow = ({team, boostedValue, onBoost}: {team: string, boostedValue: { [key: string]: number }, onBoost: (team: string, value: number) => void}) => {
  const [increase, setIncrease] = React.useState(0);
  const [decrease, setDecrease] = React.useState(0);
  const handleIncrease = (team: string) => {
    if (boostedValue && boostedValue[team] !== 0) {
      if (decrease < 0) {
        setDecrease(0);
        onBoost(team, 0);
        setIncrease(0);
      } else {
        setDecrease(0);
        onBoost(team, increase + 1);
        setIncrease(increase + 1);
      }
    }
  }
  const handleDecrease = (team: string) => {
    if (boostedValue && boostedValue[team] !== 0) {
      if (increase > 0) {
        setIncrease(0);
        onBoost(team, 0);
        setDecrease(0);
      } else {
        setIncrease(0);
        onBoost(team, decrease - 1);
        setDecrease(decrease - 1);
      }
    }
  }

  React.useEffect(() => {
    if (boostedValue && boostedValue[team] !== undefined) {
      if (boostedValue[team] > 0) {
        setIncrease(boostedValue[team]);
        setDecrease(0);
      } else if (boostedValue[team] < 0) {
        setDecrease(boostedValue[team]);
        setIncrease(0);
      } else {
        setIncrease(0);
        setDecrease(0);
      }
    } else {
      setIncrease(0);
      setDecrease(0);
    }
  },[boostedValue])

  return (
    <Stack display="flex" direction='row' justifyContent="space-between" alignItems="center" pr={1}>
      {increase > 3 ? (
        <Badge badgeContent={increase} color="success" style={{ marginRight: 4 }}>
          <img
            src={`${process.env.PUBLIC_URL}/images/boost_positive_3.svg`}
            alt=""
            style={{ marginRight: 4, cursor: boostedValue && boostedValue[team] === 0 ? 'not-allowed' : 'pointer' }}
            onClick={() => handleIncrease(team)}
          />
        </Badge>
      ) : (
        <img
          src={`${process.env.PUBLIC_URL}/images/boost_positive_${increase}.svg`}
          alt=""
          style={{ marginRight: 4, cursor: boostedValue && boostedValue[team] === 0 ? 'not-allowed' : 'pointer' }}
          onClick={() => handleIncrease(team)}
        />
      )}
      {decrease < -3 ? (
        <Badge badgeContent={Math.abs(decrease)} color="error" sx={{}}>
          <img
            src={`${process.env.PUBLIC_URL}/images/boost_negative_-3.svg`}
            alt=""
            style={{ cursor: boostedValue && boostedValue[team] === 0 ? 'not-allowed' : 'pointer' }}
            onClick={() => handleDecrease(team)}
          />

        </Badge>
      ) : (
        <img
          src={`${process.env.PUBLIC_URL}/images/boost_negative_${decrease}.svg`}
          alt=""
          style={{ cursor: boostedValue && boostedValue[team] === 0 ? 'not-allowed' : 'pointer' }}
          onClick={() => handleDecrease(team)}
        />
      )}
    </Stack>
  )
}

export default BoostOwnershipArrow